var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95372 7.14374L0.817667 1.83761C-0.0154523 1.29427 0.369297 0 1.36394 0H17.6361C18.6307 0 19.0154 1.29427 18.1823 1.83761L10.0463 7.14374C9.71426 7.36026 9.28572 7.36026 8.95372 7.14374Z",
    fill: "#BAB7AF",
    fillOpacity: 0.948,
    className: "svg-primary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.58307e-06 15V4.64024C-8.58307e-06 3.84277 0.887712 3.36613 1.55244 3.80669L8.94754 8.70793C9.28241 8.92987 9.71758 8.92986 10.0524 8.70793L17.4475 3.80669C18.1123 3.36613 19 3.84277 19 4.64024V15C19 15.5523 18.5523 16 18 16H0.999991C0.447707 16 -8.58307e-06 15.5523 -8.58307e-06 15Z",
    fill: "#BAB7AF",
    fillOpacity: 0.948,
    className: "svg-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.de998fe7.svg";
export { ForwardRef as ReactComponent };